import React from 'react';

const SpeakerIcon = ({ circleColor, pathColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={circleColor} />
      <circle cx="14.7413" cy="11.6378" r="5.43103" fill={pathColor} />
      <path
        d="M25.862 24.8276C25.862 25.8621 20.8858 30 14.7474 30C8.60889 30 4.16195 25.8621 3.10341 23.7931C4.69122 21.2069 8.60889 18.6207 14.7474 18.6207C20.8858 18.6207 25.862 23.671 25.862 24.8276Z"
        fill={pathColor}
      />
    </svg>
  );
};

export default SpeakerIcon;
